import React from 'react';
import SwipeableDrawer from 'jd-library/SwipeableDrawer';
import styles from './upload-slider.scss';

const UploadSlider = props => {
	const options = [
		{
			icon: 'icon-gallerySM',
			text: 'Gallery',
			value: 'gallery'
		}
	];

	if (props.showCameraOption) {
		options.push({
			icon: 'icon-CameraOutline',
			text: 'Camera',
			value: 'camera'
		});
	}

	return (
		<SwipeableDrawer
			onHidden={props.onHidden}
			drawerOptions={options}
			onClick={props.onOptionClick}
			title={'Upload Images'}
			className={`${styles['upload-slider']}`}
		/>
	);
};

export default UploadSlider;
